import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { isMerchantOwner } from '@/lib/auth/rbac';
import { useAuthStore } from '@/stores/auth';

export const Route = createFileRoute('/_authed/deals')({
  beforeLoad: () => {
    if (!isMerchantOwner(useAuthStore.getState().user?.role)) {
      throw redirect({
        to: '/dashboard',
        search: { period: 'today' },
        replace: true,
      });
    }
  },
  component: DealsRouteLayout,
});

function DealsRouteLayout() {
  return <Outlet />;
}
